(function () {
  'use strict';

  angular
    .module('app.authentication', [])

    /* @ngInject */
    .controller('authenticationCtrl', ["$scope", "$timeout", "AppService", function ($scope, $timeout, AppService) {
      var ctrl = this;
      ctrl.newClient = {};
      ctrl.templateCreate = '';
      ctrl.createOpen = false;

      ctrl.showCreate = function () {
        if (ctrl.templateCreate === '') {
          $scope.$emit('showPageLoader', true);
          ctrl.templateCreate = '/AccountCreate';
        } else {
          $scope.$emit('showPageLoader', false);
          ctrl.createOpen = true;
        }
      };

      ctrl.loadedAccountCreate = function () {
        $scope.$emit('showPageLoader', false);
        $timeout(function () {
          ctrl.createOpen = true;
        });
      };
      ctrl.backToAccountChoice = function () {
        ctrl.createOpen = false;
        ctrl.mobileShowLogin = false;
      };

      AppService.getTranslate()
        .then(function () {
          ctrl.active = true;
          $timeout(function () {
            ctrl.activeIn = true;
          }, 100);
        });
    }])

    /* @ngInject */
    .controller('loginController', ["$scope", "$element", "LoadService", function ($scope, $element, LoadService) {
      var ctrl = this;
      ctrl.js = $element.data('js');
      LoadService.getService('AsyncAuthenticationService', { ctrl: ctrl, scope: $scope, element: $element }, 'initLoginForm');
    }])

    /* @ngInject */
    .controller('loginModalCtrl', ["data", "device", "options", "$scope", "LoadService", function (data, device, options, $scope, LoadService) {
      var ctrl = this;
      ctrl.data = data;
      ctrl.device = device;
      ctrl.options = options;
      $scope.device = device;

      ctrl.init = function (url) {
        ctrl.js = url;
        LoadService.getService('AsyncAuthenticationService', { ctrl: ctrl, scope: $scope }, 'initModalLogin');
      };
    }])

    /* @ngInject */
    .controller('newClientController', ["$scope", "$element", "LoadService", function ($scope, $element, LoadService) {
      var ctrl = this;
      ctrl.js = $element.data('js');
      LoadService.getService('AsyncAuthenticationService', { ctrl: ctrl, scope: $scope }, 'initNewClientForm');
    }])

    /* @ngInject */
    .controller('forgotPasswordModalCtrl', ["$scope", "HttpService", "AppService", "LogService", "ModalService", function ($scope, HttpService, AppService, LogService, ModalService) {
      $scope.formData = {
        errors: [],
        Email: LogService.email
      };

      $scope.focus = function () {
        $scope.formData.errors = [];
      };

      $scope.submit = function () {
        $scope.showLoader = true;

        $scope.formData.errors = [];

        HttpService.post({
          url: '/ForgotPassword',
          data: $scope.formData
        })
        .then(function (response) {
          if (response.status === 'OK') {
            ModalService.close();
            ModalService.show(
              '/Template/Authentication/ModalForgotPasswordConfirm'
            );
          } else {
            AppService.getTranslate()
              .then(function (translate) {
                _.each(response.errors, function (error) {
                  $scope.formData.errors.push(translate.errors[error.Errors[0].ErrorMessage]);
                });
              })
              .catch(function (error) {
                console.error(error);
              });
          }
          $scope.showLoader = false;
        })
        .catch(function (error) {
          console.error(error);
        });
      };
    }]);
})();
